import Immutable from 'immutable';
import { downloadItems } from '../../data/downloads';

const downloadListItems = (state = new Immutable.Map(), action) => {
  return state.merge(
    Immutable.fromJS(
      downloadItems.reduce((map, property) => {
        map[property.id] = property;
        return map;
      }, {})
    )
  );
};

export default downloadListItems;
